<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('notificationFilter.new_metadata')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('notificationFilter.new_metadata')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2 ">
            <AccessibleElSelect
              v-model="form.campo"
              prop="campo"
              :options="listMetadatasClientForAccessibleSelect"
              :allow-create="true"
              maxlength="50"
              placeholder="Seleccionar"
              id-prefix="notificationnewmetadatadialog"
            >
              <template slot="label">
                <div class="flex items-center">
                  <div>
                    <base-obligatory-icon/> {{ $t('notificationFilter.metadata_campo')}}
                  </div>
                  <base-tooltip-icon size="sm" :section="$t('notificationFilter.metadata_campo')" :content="'Seleccione un metadato existente o escriba el nombre de uno nuevo y selecciónelo'" class="ml-2"/>
                </div>
              </template>
            </AccessibleElSelect>
            <AccessibleElSelect
              v-if="Tipo !== 0"
              v-model="form.valor"
              prop="valor"
              :options="valoresForAccessibleSelect"
              :allow-create="Tipo === 1"
              maxlength="500"
              id-prefix="notificationnewmetadatadialog"
            >
              <template slot="label"><base-obligatory-icon/>{{$t('notificationFilter.metadata_valor')}}</template>
            </AccessibleElSelect>
            <div v-else>
              <span id="notification-new-metadata-valor-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('notificationFilter.metadata_valor')}}</span>
              <el-form-item prop="valor">
                <el-input
                  type="textarea"
                  :rows="3"
                  class="w-full"
                  v-model="form.valor"
                  maxlength="500"
                  aria-labelledby="notification-new-metadata-valor-label"
                >
                  <template v-if="form.valor" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo"
                      @clear="form.valor = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="uploadNewMetadato('ruleForm')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from './base/BaseDialog.vue'
import { agregarMetadatoNEO } from '@/services/configurations/agregarMetadatoNEO'
import { agregarMetadatoRegla } from '@/services/configurations/agregarMetadatoRegla'
import { getValoresMetadatoClienteAmpliado } from '@/services/clients/getValoresMetadatoClienteAmpliado'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'

export default
{
  name: 'notification-new-metadata-dialog',
  components: {
    BaseDialog,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    notification: {
      type: Number,
      default: -1
    },
    idCliente: {
      type: Number,
      default: -1
    },
    idRegla: {
      type: Number,
      default: -1
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        campo: '',
        valor: '',
      },
      Tipo: 0,
      Valores: [],
      listMetadatasClient: [],
      rules: {
        campo: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        valor: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    listMetadatasClientForAccessibleSelect: function () {
      return this.listMetadatasClient.map(item => ({
        id: item.value,
        name: item.label,
        value: item.value
      }))
    },
    valoresForAccessibleSelect: function () {
      return this.Valores.map((item, index) => ({
        id: index,
        name: item,
        value: item
      }))
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      if (value) {
        this.form.campo = ''
        this.form.valor = ''
        this.EsLista = false
        this.Valores = []
      }
      this.downloadData()
    },
    'form.campo' (value, oldValue) {
      if (value) this.getDataMetadato()
    }
  },
  methods: {
    getDataMetadato: async function () {
      try {
        this.EsLista = false
        this.Valores = []
        this.form.valor = ''
        // this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: this.form.campo, 
          idCliente: this.idCliente, 
        }
        const response = await getValoresMetadatoClienteAmpliado(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.Tipo = response.Tipo
          this.Valores = response.Valores
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.$store.commit('setIsLoading', false)
      }
    },
    downloadData: async function () {
      this.listMetadatasClient = []
      const respuestaMetadataClient = await getListMetadatas({ idCliente: this.idCliente })
      if (respuestaMetadataClient.blnError) {
        this.doFeedback(respuestaMetadataClient.msgError + ' [Código de error: ' + respuestaMetadataClient.codError + ']')
      } else {
        this.listMetadatasClient = respuestaMetadataClient.Respuesta.map(x => ({ value: x.Campo, label: x.Campo }))
      }
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.form.campo = ''
      this.form.valor = ''
      this.$emit('toggleDialog')
    },
    uploadNewMetadato: async function (ruleForm) {
      try {
        this.$refs[ruleForm].validate(async valid => {
          this.$store.commit('setIsLoading', true)
          if (valid) {
            const payload = { 
              idNEO: this.notification, 
              Campo: this.form.campo, 
              Valor: this.form.valor, 
              idRegla: this.idRegla,
            }
            let response
            if (this.idRegla === -1 && this.notification === -1) {
              this.$emit('applyDialog', payload)
              this.$store.commit('setIsLoading', false)
            } else {
              if (this.idRegla === -1) {
                response = await agregarMetadatoNEO(payload)
              } else {
                response = await agregarMetadatoRegla(payload)
              }
              if (response.blnError === true) {
                this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
              } else {
                this.$emit('applyDialog')
                this.doFeedback('Metadato añadido correctamente', 'success')
              }
              this.$store.commit('setIsLoading', false)
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

</style>
